import useObjectRelationGqlRequest from "./useObjectRelationGqlRequest";
import { useSelector } from "react-redux";
import { useState } from "react";
import func from "@uikit/func";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function useSaveProject() {
  const navigate = useNavigate();
  const urlParam = useParams();
  const { gql } = useObjectRelationGqlRequest();
  const userMe = useSelector(state => state.editor.me);

  const [loading, setLoading] = useState(false);

  /*
    attributes: updated attributes to be saved
    attr_indexer: attr_indexer or uuid of existing project
    projectId: objectId of existing project
  */
  const saveProject = async (attributes, projectId, notShowSuccessTip) => {
    try {
      setLoading(true);
      // get existing relation
      const existingRelation = await gql.query.relationSet({
        name: "studio_project",
        destId: parseInt(projectId),
      });
      const originalProject = existingRelation[0];
      const relationId = originalProject?.relationId || "";
      if (!relationId) {
        setLoading(false);
        throw Error("existing project may have been deleted");
      }

      // get user me object id
      const userMeObjectId = userMe.objectId;
      if (!userMeObjectId) {
        setLoading(false);
        throw Error("empty user meobject id");
      }

      // create new object based on updated attributes
      attributes.index = originalProject.attrIndexer || originalProject.uuid;
      const updatedProject = await gql.mutation.createObject(
        {
          name: "studio_project",
          attributes,
        },
        null
      );

      // remove relationship of old project
      await gql.mutation.deleteRelations([relationId], null);

      // create relation of new project
      try {
        await gql.mutation.createRelation(
          {
            sourceId: parseInt(userMeObjectId),
            destId: parseInt(updatedProject.id),
            type: "studio_project",
          },
          null
        );
      } catch (error) {
        // restore old relationship on error and re raise exception
        await gql.mutation.createRelation(
          {
            sourceId: parseInt(userMeObjectId),
            destId: parseInt(projectId),
            type: "studio_project",
          },
          null
        );
        setLoading(false);
        throw Error(`save project failed: create relation with updated project failed - ${error.message}`);
      }
      // create studio_archive relation between updated project and old project
      const tips = notShowSuccessTip ? null : "Successfully created";
      await gql.mutation.createRelation(
        {
          sourceId: updatedProject.id,
          destId: projectId,
          type: "studio_archive",
        },
        tips
      );

      setLoading(false);

      const updatedProjectAttributes = updatedProject.attributesV2;
      updatedProjectAttributes.id = updatedProject.id;
      updatedProjectAttributes.uuid = updatedProject.uuid;
      if (!func.isEmpty(urlParam.attrIndexer) && updatedProject.attrIndexer !== urlParam.attrIndexer) {
        navigate(`/editor/${updatedProject.attrIndexer}`);
      }
      return updatedProjectAttributes;
    } catch (error) {
      func.messageError(error);
      return Promise.reject(error);
    }
  };

  return {
    saveProject,
    loading,
  };
}
